import { useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined'
import { BootstrapTooltip } from '../tooltips/Tooltip/BootStrapToopTip'
import { AllState } from '../../../store'
import { selectIsPanelOpen, toggleChatPanel } from '../../../store/aiAgentChat'
import { HeaderChatButton } from './styles'

/**
 * ヘッダーに常設するAIエージェントチャットの起動ボタン。
 * パネル本体(AiAgentChat)とは離れた位置に描画されるため、開閉状態はReduxで共有する。
 */
export const AiAgentChatHeaderButton = () => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const isPanelOpen = useSelector((state: AllState) => selectIsPanelOpen(state))
  const label = intl.formatMessage({ id: 'aiAgentChat.title' })

  return (
    <BootstrapTooltip arrow={true} title={label}>
      <HeaderChatButton
        isActive={isPanelOpen}
        aria-label={label}
        onClick={() => dispatch(toggleChatPanel())}
      >
        <SmartToyOutlinedIcon />
      </HeaderChatButton>
    </BootstrapTooltip>
  )
}
